import _ from 'lodash';
import { useEffect, useState } from 'react';
import { SHOW_COMMEMORATE } from 'src/constants';
import { convertDatasets } from 'src/utils/datasets';
import { convertObjPath, timestamp } from 'src/utils/helper';
import { GET_ARTICLES } from 'src/utils/services';
import styled from 'styled-components';
import CardV from './section-schneider/components/card-v';

function SectionBitkub({ dataBitkub, eventDataLayer }) {
  const backgroundDesktop = convertDatasets(dataBitkub?.dataSet, 'background-desktop', true);
  const backgroundMobile = convertDatasets(dataBitkub?.dataSet, 'background-mobile', true);
  const tagNameLeft = convertDatasets(dataBitkub?.dataSet, 'tag-name-left', true);
  const tagNameRight = convertDatasets(dataBitkub?.dataSet, 'tag-name-right', true);
  if ((_.isEmpty(tagNameRight) && _.isEmpty(tagNameLeft)) || (_.isEmpty(backgroundDesktop) || _.isEmpty(backgroundMobile))) {
    return null;
  }
  const [resData, setResData] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const res = await Promise.all([
          GET_ARTICLES(
            `/api/search/tag${convertObjPath({
              name: tagNameLeft,
              limit: 1
            })}`,
            false,
            true
          ),
          GET_ARTICLES(
            `/api/search/tag${convertObjPath({
              name: tagNameRight,
              limit: 1
            })}`,
            false,
            true
          )
        ]);
        if (!_.isEmpty(res)) return setResData(res);
      } catch (err) {
        console.error(`${timestamp()} ==========> EVENT_007 ERROR :`, err?.message);
      }
    })();
  }, []);
  return (
    <SectionWrapper
      style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}
      background={{
        desktop: backgroundDesktop,
        mobile: backgroundMobile
      }}
    >
      <img src={backgroundDesktop} className='background-desktop' />
      <img src={backgroundMobile} className='background-mobile' />
      <div className='card-wrapper'>
        {!_.isEmpty(tagNameLeft) && (
          <CardV
            data={resData[0]?.data[0]}
            path={resData[0]?.data[0]?.link}
            description={false}
            showPageviews={false}
            withBG={true}
            //! DATALAYER
            eventDataLayer={{
              ...eventDataLayer,
              data: {
                ...eventDataLayer?.data,
                title: resData[0]?.data[0]?.title
              }
            }}
          />
        )}
        {!_.isEmpty(tagNameRight) && (
          <CardV
            data={resData[1]?.data[0]}
            path={resData[1]?.data[0]?.link}
            description={false}
            showPageviews={false}
            withBG={true}
            //! DATALAYER
            eventDataLayer={{
              ...eventDataLayer,
              data: {
                ...eventDataLayer?.data,
                title: resData[1]?.data[0]?.title
              }
            }}
          />
        )}
      </div>
    </SectionWrapper>
  );
}
const SectionWrapper = styled.div`
  background-image: url(${props => props.background.desktop});
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: auto;
  @media (max-width: 1023px) {
    background-image: url(${props => props.background.mobile});
  }
  .background-desktop {
    position: relative;
    width: 100%;
    visibility: hidden;
    @media (max-width: 1023px) {
   display: none;
  }
  }
  .background-mobile{
    position: relative;
    width: 100%;
    visibility: hidden;
    @media (min-width: 1024px) {
   display: none;
  }
  }
  .card-wrapper {
    position: absolute;
    top: 52%;
    left: 48%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 29%;
    gap: 20px;
    @media (max-width: 1023px) {
    top: 58.5%;
    left: 50%;
    width: 100%;
    padding: 0 50px;
    gap: 35px;
    }
    @media (max-width: 768px) {
    top: 58%;
    left: 50%;
    width: 100%;
    padding: 0 35px;
    gap: 25px;
    }
    @media (max-width: 550px) {
    top: 59%;
    padding: 20px;
    gap: 11px;
    }
    @media (max-width: 375px) {
      top: 59%;
      padding: 15px;
    }
  }
  
`;
export default SectionBitkub;
